import { createContext } from 'react'

// import { AskDoctorContextProps } from './types'

const AskDoctorContext = createContext({} as any)
export { AskDoctorContext }
